export default __webpack_public_path__ + "static/media/portfolio-132.5f1f07a2.jpg";